var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 58,
    viewBox: "0 0 66 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6159 9.07891C57.6666 6.38922 45.0392 0 45.0392 0V6.14316C45.0392 7.21225 26.323 19.4941 21.5504 21.9419C17.2066 23.9698 8.39728 18.985 8.39728 18.985L1.39604 22.7692C0.534028 23.2316 0.0168191 24.1438 0.0420488 25.1322L0 46.7686L17.7575 57.1074C18.1233 57.3195 18.5228 57.4256 18.9223 57.4256C19.3133 57.4256 19.7086 57.3238 20.0618 57.1159C26.2178 53.5947 57.2504 35.7086 63.7933 29.4044C64.8151 28.4159 65.3995 27.0329 65.3995 25.6074V13.8304C65.3953 11.8365 64.3273 10.0165 62.6117 9.07891H62.6159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo-3.a1a9082326f73e9464c211cf52b75a1d.svg";
export { ForwardRef as ReactComponent };